// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Receipt48FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Receipt48Filled: FC<Receipt48FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="M4 44V8.286c0-1.179.42-2.188 1.259-3.027C6.099 4.419 7.107 4 8.286 4h31.428c1.179 0 2.188.42 3.027 1.259.84.84 1.259 1.848 1.259 3.027V44H4Zm14.286-8.571h17.142v-4.286H18.287v4.286Zm-5.715-9.286H35.43v-4.286H12.57v4.286Zm0-9.286H35.43v-4.286H12.57v4.286Z" />
        </svg>
    );
};

export default Receipt48Filled;
